<template>
	<div class="home_content">
		<div class="banner">
			<el-carousel height="574px">
				<el-carousel-item v-for="(item,index) in detail.index_one_ads" :key="item">
					<img :src="imgBaseUrl+item" alt="">
				</el-carousel-item>
			</el-carousel>
			
		</div>
		<div class="introduction flex align-center justify-between">
			<img :src="imgBaseUrl + detail.index_two_image" alt="">
			<div class="info">{{detail.index_two_text}}</div>
		</div>
		<div class="floor_second">
			<div class="title">{{detail.index_two_introduction_title}}</div>
			<div class="second_title" v-html="detail.index_two_introduction_text"></div>
			<ul class="list flex">
				<li class="item" v-for="(item,index) in classifyList" :key="item" @click="toClasses">
					<div class="picture">
						<img :src="imgBaseUrl+item.image" alt="">
						<div class="tag">
							<div>{{item.name}}</div>
							<div>{{item.age}}</div>
						</div>
					</div>
					<!-- <div class="info">{{item.age}}</div> -->
					<div class="info">{{item.introduction}}</div>
				</li>
			</ul>
			<div class="btn" @click="toClasses">Book Now</div>
		</div>
		<div class="floor_third">
			<ul class="longe_list">
				<li class="item">
					<div class="intro">
						<div class="title">{{detail.index_three_introduction_title_one}}</div>
						<div class="info">{{detail.index_three_introduction_content_one}}</div>
					</div>
					<img :src="imgBaseUrl + detail.index_three_introduction_image_one" alt="">
				</li>
				<li class="item">
					<img :src="imgBaseUrl + detail.index_three_introduction_image_two" alt="">
					<div class="intro">
						<div class="title">{{detail.index_three_introduction_title_two}}</div>
						<div class="info">{{detail.index_three_introduction_content_two}}</div>
						<div class="btn" @click="toClassPack">More info</div>
					</div>
				</li>
				<li class="item">
					<img :src="imgBaseUrl + detail.index_four_introduction_images_one" alt="">
					<div class="intro">
						<div class="title">{{detail.index_four_introduction_title_one}}</div>
						<div class="info">{{detail.index_four_introduction_content_one}}</div>
						<div class="btn" @click="toContact">More info</div>
					</div>
				</li>
			</ul>
		</div>
		<div class="floor_four">
			<div class="title">{{detail.index_four_introduction_title_two}}</div>
			<div class="second_title">{{detail.index_four_introduction_content_two}}</div>
			<ul class="floor_banner">
				<li class="item" v-for="(item,index) in detail.index_four_introduction_images_two">
					<img :src="imgBaseUrl+item" alt="">
				</li>
				
			</ul>
			<div class="btn" @click="toParentClass">Book Now</div>
			<ul class="example">
				<li class="item">
					<div class="example_title">PARTIES</div>
					<img :src="imgBaseUrl+detail.index_five_introduction_image_left" alt="">
					<div class="intro">{{detail.index_five_introduction_content_left}}</div>
					<div class="btn" @click="toPrties">More info</div>
				</li>
				<li class="item">
					<div class="example_title">EVENTS</div>
					<img :src="imgBaseUrl+detail.index_five_introduction_image_right" alt="">
					<div class="intro">{{detail.index_five_introduction_content_right}}</div>
					<div class="btn" @click="toEvents">More info</div>
				</li>
			</ul>
			<div class="shop">
				<img :src="imgBaseUrl+detail.index_six_introduction_images" alt="">
				<div class="shop_info">
					<div class="shop_title">SHOP</div>
					<div class="shop_intro">{{detail.index_six_introduction_content}}</div>
					<div class="btn" @click="toShop">Shop Now</div>
				</div>
			</div>
		</div>
		<div class="model" v-if="addEmail">
			<div class="model_content">
				<div class="model_title">Curious?</div>
				<img @click="addEmail = false" class="close" src="../../assets/images/icon/close.png" alt="">
				<div class="model_info">Pop in your email to get access to exclusive deals, special discounts and the opportunity to attend free exciting events at Curiouser ! </div>
				<div class="input_box flex align-center justify-center">
					<input type="text" v-model="email">
					<div class="submit" @click="submitEmail">submit</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				imgBaseUrl:this.$api.imgBaseUrl,
				detail:{},
				classifyList:[],
				email:'',
				addEmail:false,
				isClick:false
			}
		},
		created(){
			this.getSystem();
			this.getClassify();
			var token = localStorage.getItem('token');
			if(!token){
				this.addEmail = true;
			}
		},
		methods:{
			submitEmail(){
				if(this.isClick){
					return
				}
				this.isClick = true;
				if(!this.email){
					this.$message({
						showClose:true,
						duration:0,
						message:'Please enter a valid email address'
					})
					return
				}
				this.$api.post('common/email',{email:this.email},res=>{
					if(res.code == 1){
						this.isClick = false;
						this.$message({
							showClose:true,
							duration:0,
							message:'Successful'
						})
						this.addEmail = false;
					}else{
						this.isClick = false;
						this.$message({
							showClose:true,
							duration:0,
							message:res.msg
						})
					}
				})
			},
			toClasses(){
				this.$emit('changeMenu',{type:2})
				this.$router.push('/home/classes')
			},
			toClassPack(){
				this.$emit('changeMenu',{type:3})
				this.$router.push('/home/classPack')
			},	
			toContact(){
				this.$emit('changeMenu',{type:9})
				this.$router.push('/home/contact')
			},
			toParentClass(){
				this.$emit('changeMenu',{type:4})
				// this.$router.push('/home/parentClass')
				this.$router.push('/home/parent')
			},
			toPrties(){
				this.$emit('changeMenu',{type:5})
				this.$router.push('/home/party')
			},
			toEvents(){
				this.$emit('changeMenu',{type:6})
				this.$router.push('/home/events')
			},
			toShop(){
				this.$emit('changeMenu',{type:8})
				this.$router.push('/home/mall')
			},
			getSystem(){
				this.$api.post('common/getsystem',{type:'index'},res=>{
					if(res.code == 1){
						res.data.index_four_introduction_images_two = res.data.index_four_introduction_images_two.split(',');
						res.data.index_one_ads = res.data.index_one_ads.split(',')
						this.detail = res.data;
					}
				})
			},
			getClassify(){
				this.$api.post('Course/getCourseType',{},res=>{
					if(res.code == 1){
						this.classifyList = res.data;
					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	
	.home_content{
		.btn{
			width: 182px;
			height: 58px;
			background: #5C707A;
			border-radius: 29px;
			line-height: 58px;
			text-align: center;
			font-size: 20px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #F7F2EB;
			margin: 0 auto;
			cursor: pointer;
		}
		.banner{
			width: 100%;
			height: 574px;
			
			img{
				width: 100%;
				height: 100%;
			}
			::v-deep .el-carousel__indicators--horizontal{
				display: block;
				
			}
			::v-deep .el-carousel__indicator--horizontal button{
				display: block;
				width: 8px;
				height: 8px;
				background: #FFFFFF;
				opacity: 0.3;
				border-radius: 50%;
				padding: 0 ;
				margin-right: 30px;
			}
			::v-deep .el-carousel__indicator--horizontal.is-active button{
				opacity: 1;
			}	
		}
		.introduction{
			width: 1200px;
			margin: 34px auto;
			img{
				width: 400px;
				height: 300px;
			}
			.info{
				width: 770px;
				font-size: 18px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #282E30;
				line-height: 30px;
			}
		}
		.floor_second{
			width: 1200px;
			margin: 0 auto;
			padding-top: 77px;
			.title{
				font-size: 22px;
				font-family: Source Han Sans CN;
				font-weight: bold;
				color: #282E30;
				margin-bottom: 24px;
			}
			.second_title{
				font-size: 18px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #282E30;
				line-height: 36px;
				text-align: left;
			}
			.list{
				flex-wrap: wrap;
				margin-bottom: 10px;
				.item{
					width: 290px;
					margin-right: 13px;
					margin-bottom: 30px;
					cursor: pointer;
					.picture{
						width: 100%;
						height: 260px;
						border-radius: 10px;
						overflow: hidden;
						position: relative;
					}
					img{
						width: 100%;
						height: 100%;
					}
					.tag{
						width: 100%;
						height: 90px;
						background-color: rgba(255,255,255,0.8);
						position: absolute;
						left: 0;
						bottom: 30px;
						line-height: 30px;
						text-align: center;
						font-size: 16px;
						font-family: Source Han Sans CN;
						font-weight: bold;
						color: #BF5F49;
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: center;
						div{
							text-align: center;
						}
					}
					
					.info{
						font-size: 20px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #282E30;
						margin-top: 17px;
						text-align: left;
					}
					&:nth-child(4n+0){
						margin-right: 0;
					}
				}
			}
			
		}
		.floor_third{
			width: 1200px;
			margin: 0 auto;
			margin-top: 40px;
			.longe_list{
				.item{
					display: flex;
					align-items: center;
					justify-content: space-between;
					margin-bottom: 40px;
					text-align: left;
					.intro{
						width: 661px;
						.title{
							font-size: 22px;
							font-family: Source Han Sans CN;
							font-weight: bold;
							color: #282E30;
							margin-bottom: 19px;
						}
						.info{
							font-size: 18px;
							font-family: Source Han Sans CN;
							font-weight: 400;
							color: #282E30;
							line-height: 30px;
							text-align: left;
						}
						.btn{
							margin-top: 20px;
						}
					}
					img{
						width: 500px;
						height: 300px;
					}
				}
			}
		}
		.floor_four{
			width: 1200px;
			margin: 0 auto;
			margin-top: 92px;
			.title{
				font-size: 22px;
				font-family: Source Han Sans CN;
				font-weight: bold;
				color: #282E30;
				text-align: center;
			}
			.second_title{
				font-size: 18px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #282E30;
				line-height: 30px;
				text-align: left;
				margin-top: 24px;
				margin-bottom: 28px;
			}
			.floor_banner{
				display: flex;
				width: 100%;
				overflow-y: scroll;
				margin-bottom: 40px;
				.item{
					width: 290px;
					height: 300px;
					margin-right: 13px;
					img{
						width: 100%;
						height: 100%;
					}
					&:last-child{
						margin-right: 0;
					}
				}
			}
			.example{
				display: flex;
				// align-items: center;
				justify-content: space-between;
				margin-top: 80px;
				.item{
					width: 560px;
					.example_title{
						font-size: 22px;
						font-family: Source Han Sans CN;
						font-weight: bold;
						color: #282E30;
						margin-bottom: 30px;
						text-align: center;
					}
					img{
						width: 560px;
						height: 600px;
					}
					.intro{
						font-size: 18px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #282E30;
						line-height: 30px;
						margin-top: 30px;
						text-align: left;
						margin-bottom: 20px;
						height: 180px;
					}
				}
			}
			.shop{
				margin-top: 70px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				img{
					width: 500px;
					height: 300px;
				}
				.shop_info{
					width: 660px;
					text-align: left;
					.shop_title{
						font-size: 22px;
						font-family: Source Han Sans CN;
						font-weight: bold;
						color: #282E30;
						margin-bottom: 20px;
					}
					.shop_intro{
						font-size: 18px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #282E30;
						margin-bottom: 30px;
						line-height: 30px;
					}
					.btn{
						margin-left: 0;
					}
				}
			}
		}
	}
	.model{
		position: fixed;
		top: 0;
		left:0;
		bottom: 0;
		right:0;
		background: rgba(0,0,0,0.3);
		.model_content{
			width: 500px;
			height: 300px;
			position: absolute;
			left: 50%;
			top:50%;
			transform: translate(-50%,-50%);
			background-color: #F7F2EB;
			padding: 32px;
			border-radius: 20px;
			.model_title{
				font-size: 24px;
				font-weight: bold;
				color: #282E30;
				text-align: center;
			}
			.close{
				position: absolute;
				top: 32px;
				right: 32px;
				width: 20px;
				height: 20px;
				cursor: pointer;
			}
			.model_info{
				font-size: 22px;
				line-height: 30px;
				color: #282E30;
				margin-top: 10px;
			}
			.input_box{
				margin-top: 20px;
				input{
					width: 300px;
					height:60px;
					padding: 0 10px;
					line-height: 60px;
					font-size: 22px;
					color: #282E30;
					border: 1px solid #5C707A;
					border-radius: 10px 0 0 10px;
				}
				.submit{
					width: 120px;
					height: 60px;
					font-size: 24px;
					color: #fff;
					background-color: #5C707A;
					text-align: center;
					line-height: 60px;
					border-radius: 0 10px 10px 0;
					cursor: pointer;
				}
			}
		}
	}
</style>